<c11n-modal-dialog #saveDraftModal modalId="saveDraftModal" [headingText]="content.header">
  <div c11n-modal-dialog-body>
    <p class="c11n-text-md" data-cy="save-draft-modal-content">{{ content.content }}</p>

    <div aria-live="polite" aria-atomic="true">
      <div *ngIf="draftsLoading" class="save-draft-modal__loading" data-cy="save-draft-loading" role="status">
        <c11n-spinner size="medium" colorMode="on-light"></c11n-spinner>
        <span>{{content.loading}}</span>
      </div>
    </div>

    <table *ngIf="!draftsLoading" class="save-draft-table" data-cy="save-draft-table">
      <thead>
        <tr>
          <th class="c11n-text-xs save-draft-table__header">{{ content.columns.initiator }}</th>
          <th class="c11n-text-xs save-draft-table__header">{{ content.columns.dateStarted }}</th>
          <th class="c11n-text-xs save-draft-table__header">{{ content.columns.requestType }}</th>
          <th class="c11n-text-xs save-draft-table__header">{{ content.columns.actions }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let draft of drafts" data-cy="save-draft-row">
          <td class="save-draft-table__cell">
            <span
              class="save-draft-badge"
              [ngClass]="{ 'save-draft-badge--crew': draft.initiator === 'crew' }"
              data-cy="save-draft-initiator"
            >
              {{ draft.initiator === 'client' ? content.initiatorLabels.client : content.initiatorLabels.crew }}
            </span>
          </td>
          <td class="save-draft-table__cell c11n-text-md" data-cy="save-draft-date">
            {{ draft.dateStarted | date: 'MM/dd/yyyy' }}
          </td>
          <td class="save-draft-table__cell c11n-text-md" data-cy="save-draft-request-type">
            {{ draft.requestType }}
          </td>
          <td class="save-draft-table__cell save-draft-table__actions">
            <button
              class="save-draft-action-btn save-draft-action-btn--delete"
              [attr.aria-label]="content.deleteDraftAriaLabel"
              (click)="onDeleteDraft(draft)"
              data-cy="save-draft-delete-btn"
            >
              <c11n-icon name="trash" size="small"></c11n-icon>
            </button>
            <button
              class="save-draft-action-btn save-draft-action-btn--retrieve"
              [attr.aria-label]="content.retrieveDraftAriaLabel"
              (click)="onRetrieveDraft(draft)"
              data-cy="save-draft-retrieve-btn"
            >
              <c11n-icon name="caret-right" size="small"></c11n-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="save-draft-modal__buttons">
      <c11n-button
        [labelText]="content.cancel"
        (clickEvent)="closeModal()"
        data-cy="save-draft-cancel-btn"
      ></c11n-button>
    </div>
  </div>
</c11n-modal-dialog>
